import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const CommonCard = styled(Box)(({ theme, sx }) => ({
    backgroundColor: theme.palette.figma.block,
    borderRadius: '20px',
    padding: '20px',
    boxShadow: theme.palette.shadows?.custom?.card || '0px 2px 8px rgba(0, 0, 0, 0.1)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    alignItems: 'center',
    cursor: 'default',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: theme.palette.shadows?.elevation?.[4] ?? '0px 20px 25px -5px rgba(0, 0, 0, 0.1)',
    },
    '&:active': {
        transform: 'translateY(0px)',
        boxShadow: theme.palette.shadows?.custom?.card || '0px 2px 8px rgba(0, 0, 0, 0.1)',
    },
    '&:focus': {
        outline: 'none',
    },
    ...sx,
}));

export default CommonCard;
